function queueNextSlide(handleSlide, slide, nextSlide, delay) {
	setTimeout(() => {
		handleSlide(nextSlide);
	}, delay);
	console.log("clicked rejistered, current slide:", slide);
}

export default queueNextSlide;
